import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NoteTypeEnum } from './note-type.enum';
import { NoteModel } from './note.model';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  imports: [NgClass, MatIcon],
})
export class NoteComponent {
  @Output() public linkClickedEvent = new EventEmitter<void>();
  @Input() public note: NoteModel;
  public noteTypeError = NoteTypeEnum.Error;
  public noteTypeInformation = NoteTypeEnum.Information;
  public noteTypeWaiting = NoteTypeEnum.Waiting;
  public noteTypeWarning = NoteTypeEnum.Warning;

  private _router = inject(Router);

  public performAction(): void {
    if (this.note && this.note.link) {
      this._router.navigateByUrl(this.note.link);
      this.linkClickedEvent.emit();
    }
  }
}
